import { BillStatus, enumBillStatus } from '@rematter/frontend-lib-api-client';
import { SearchField, Toggle, ToggleButtonGroup } from '@rematter/ui-web';
import { useAtom } from 'jotai';

import * as state from '../../_state/billList.state';

import { useDebouncedAtom } from '~/shared/hooks/useDebouncedAtom';

export type BillStatusToggleProps = {
  id: string;
  count?: number;
  label: string;
  disabled?: boolean;
};

const BillStatusToggle = ({
  id,
  count = 0,
  label,
  disabled,
}: BillStatusToggleProps) => (
  <Toggle id={id} isDisabled={disabled} className="@BillStatusToggle">
    <div className="flex items-center gap-1.5">
      <span>{label}</span>
      {!!count && (
        <span className="rounded-md bg-neutral/10 px-1 text-xs">{count}</span>
      )}
    </div>
  </Toggle>
);

export const BillListFilterBar = () => {
  const [statusFilter, setStatusFilter] = useAtom(state.$billStatusFilter);
  const [search, setSearch] = useDebouncedAtom(state.$searchParam, 300);

  return (
    <div className="@BillListFilterBar flex items-center gap-2 p-4">
      <ToggleButtonGroup
        selectionMode="single"
        selectedKeys={statusFilter ? [statusFilter] : [enumBillStatus.Pending]}
        onSelectionChange={(v) => {
          const value = Array.from(v.values())[0] as BillStatus;
          setStatusFilter(value);
        }}
      >
        {[
          enumBillStatus.Pending,
          enumBillStatus.Paid,
          enumBillStatus.Voided,
        ].map((status) => (
          <BillStatusToggle key={status} id={status} label={status} />
        ))}
      </ToggleButtonGroup>
      <SearchField
        autoFocus
        placeholder="Search bills"
        aria-label="Search bills"
        value={search}
        className="h-[34px] w-[250px] [&>div]:h-full"
        onChange={(value) => setSearch(value ?? '')}
      />
    </div>
  );
};
